<template>
  <ComparisonCard
    :title="story.title"
    :text="story.excerpt"
    :to="{ name: 'success-story', params: { slug: story.slug } }"
    :aria-label="`Read story: ${story.title}`"
  />
</template>

<script>
import ComparisonCard from '@/components/comparison/ComparisonCard.vue';

export default {
  components: {
    ComparisonCard,
  },
  props: {
    story: {
      type: Object,
      required: true,
    },
  },
};
</script>
